import { useEffect, useState, type ComponentType } from "react";

type IdleWindow = Window & {
  requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => number;
};

/**
 * Loads the toast container after hydration so the sonner bundle stays out of
 * the entry chunk. Toasts fired before it mounts are kept by sonner's own queue
 * and rendered as soon as the container appears.
 */
export function LazyToaster() {
  const [Toaster, setToaster] = useState<ComponentType | null>(null);

  useEffect(() => {
    let mounted = true;
    const load = () => {
      void import("@/components/ui/sonner").then((mod) => {
        if (mounted) setToaster(() => mod.Toaster as unknown as ComponentType);
      });
    };
    const idleWindow = window as IdleWindow;
    if (typeof idleWindow.requestIdleCallback === "function") {
      idleWindow.requestIdleCallback(load, { timeout: 2000 });
    } else {
      setTimeout(load, 500);
    }
    return () => {
      mounted = false;
    };
  }, []);

  return Toaster ? <Toaster /> : null;
}
